var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading.books
    ? _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "text-center" },
            [
              _c(
                "v-card",
                { attrs: { outlined: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c("loading-linear", {
                        attrs: { message: "Loading Relevant Titles ..." },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        [
          !_vm.isMobilePort && _vm.books.length
            ? _c(
                "divider-expand",
                {
                  attrs: {
                    "open-by-default": _vm.showRelevantTitles,
                    activateSearchTab: this.$getConst("titleSearchType"),
                    buttonText: "See More Titles",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "expand",
                        fn: function () {
                          return [
                            _c("title-list", {
                              attrs: {
                                titles: _vm.books,
                                loading: _vm.loading.books,
                                itemsPerPage: _vm.itemsPerPage,
                                displayCompacted: "",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    471924858
                  ),
                },
                [
                  _c(
                    "p",
                    { staticClass: "fs-14 mb-0 d-inline font-weight-medium" },
                    [_vm._v("\n            Relevant Titles\n        ")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }